// extracted by mini-css-extract-plugin
export default {"landingPage":"Body_landingPage__OzG+u","content":"Body_content__N5lIl"};